/* eslint-disable no-dupe-keys */

// ============================================================
// Environment identifiers
// ============================================================
export const ENV_DEV_UI = 'development_ui';
export const ENV_DEV_K8 = 'development_k8';
export const ENV_DEV_K8_BETA = 'development_k8_beta';
export const ENV_STAGING_K8 = 'staging_k8';
export const ENV_STAGING_BETA_K8 = 'staging_beta_k8';
export const ENV_STAGING_BETA1_K8 = 'staging_beta1_k8';
export const ENV_STAGING_BETA2_K8 = 'staging_beta2_k8';
export const ENV_STAGING_BETA3_K8 = 'staging_beta3_k8';
export const ENV_STAGING_BETA4_K8 = 'staging_beta4_k8';
export const ENV_STAGING_BETA5_K8 = 'staging_beta5_k8';
export const ENV_PRODUCTION_R1 = 'production_r1';
export const ENV_PRODUCTION_R2 = 'production_r2';
export const ENV_PRODUCTION_BETA_K8 = 'production_us_beta_K8';
export const ENV_PRODUCTION_BETA1_K8 = 'production_us_beta1_K8';
export const ENV_PRODUCTION_BETA2_K8 = 'production_us_beta2_K8';
export const ENV_PRODUCTION_BETA3_K8 = 'production_us_beta3_K8';
export const ENV_PRODUCTION_BETA4_K8 = 'production_us_beta4_K8';
export const ENV_PRODUCTION_BETA5_K8 = 'production_us_beta5_K8';
export const ENV_PRODUCTION_EU_BETA_K8 = 'production_eu_beta_k8';

// ============================================================
// Domain URLs
// ============================================================
export const DEV_UI_URL = 'localhost';
export const DEV_K8_URL = 'ws.r1.cortix.ai';
export const DEV_K8_URL_BETA = 'ws.r1.cortix.ai';
export const STAGING_K8_URL = 'ws.r2.cortix.ai';
export const PRODUCTION_EU_URL = 'access.cortix.ai';
export const PRODUCTION_US_URL = 'insights.cortix.ai';

// ============================================================
// Beta path segments
// ============================================================
export const PATH_K8_BETA = '/beta/insights';
export const PATH_K8_BETA1 = '/beta1/insights';
export const PATH_K8_BETA2 = '/beta2/insights';
export const PATH_K8_BETA3 = '/beta3/insights';
export const PATH_K8_BETA4 = '/beta4/insights';
export const PATH_K8_BETA5 = '/beta5/insights';

// ============================================================
// External links
// ============================================================
export const EULA_LINK =
  'https://preview.abound.carrier.com/en/worldwide/media/End%20User%20License%20Agreement%20(%E2%80%9CEULA%E2%80%9D)%20for%20Abound%20Insights%20Platform_tcm1101-258063.pdf';

export const TOU =
  'https://www.shareddocs.com/hvac/docs/2003/Public/0D/Abound_insight_TOU.pdf';

// ============================================================
// Firebase API keys
// ============================================================
export const FIREBASE_AK_DEV = 'AIzaSyBaSS09_kBE8QP-Ryqt8wh_UaAI2i56aXg';
export const FIREBASE_AK = 'AIzaSyBpylIxAdAgkKIYf9XlYd7IBw7nXqQkcMo';

// ============================================================
// Application Insights connection strings
// ============================================================
const APP_INSIGHTS = {
  DEV: 'InstrumentationKey=d98477b1-b167-4631-a13b-66c0808716ec;IngestionEndpoint=https://westeurope-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=9533ccf5-5a34-4cf3-959a-0a0ae472c87b', // TODO: replace with DEV App Insights connection string
  INT: 'InstrumentationKey=b05e41a8-c190-46bc-b562-7994bab02852;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=fb24e0f8-e35d-49a7-b9f3-9201445ee604', // TODO: replace with INT/Staging App Insights connection string
  PROD_EU:
    'InstrumentationKey=b05e41a8-c190-46bc-b562-7994bab02852;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=fb24e0f8-e35d-49a7-b9f3-9201445ee604',
  PROD_US:
    'InstrumentationKey=6a2b57ef-64be-4526-9476-ed8c52e6dde1;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=bd9f76fc-0ab7-4281-9ddf-5b77e52e5042',
};
// Intercom Messenger
// ============================================================
// Workspace ("app") id from Intercom Settings > Installation.
export const INTERCOM_APP_ID = 'mcilztdk';
export const INTERCOM_APP_ID_PROD_US = 'sj2cm240';

// ============================================================
// Azure Map credentials
// ============================================================
const AZURE_MAP = {
  DEV_CLIENT: 'aee0731a-d5bb-45de-a885-ab2ac51bbfd4',
  DEV_ACCESS: '9073956c9e904723aaafa838b111c9d2',
  INT_ACCESS: 'ce3e3090262740a8bbe2b1f34aa11df3',
  PROD_US_CLIENT: 'a4ef7782-528a-4e9a-b3c9-f06a42189e10',
  PROD_US_ACCESS: 'a6c0e2b692894960b28b4f05f29add1a',
  PROD_EU_CLIENT: '60f9f3ff-8669-465c-a283-dd06e051f82e',
  PROD_EU_ACCESS: 'b0a7ff4d9cb34bbb914da34d1c408a2d',
};

// ============================================================
// Shared configuration defaults (common to all environments)
// ============================================================
const SHARED_DEFAULTS = {
  cacheLocation: 'localStorage',
  scopes: ['openid', 'profile', 'offline_access'],
  defaultMeasurement: 'unit2',
  defaultLanguage: {
    languageCode: 'en',
    language: 'english',
    value: 'en',
    label: 'English',
  },
  cacheEnabled: true,
  view: {
    autoCollapse: false,
    navHistoryMaxDays: 2,
    multiFilter: true,
    showPAIRecoveryDays: false,
  },
  apiTimeout: '300000',
};

// ============================================================
// API version templates
// ============================================================

// Production non-beta baseline (all endpoints without /beta prefix)
const BASE_API_VERSIONS = {
  userdet: '/v1',
  userPreference: '/v2',
  inventoryReport: '/v2',
  getTile: '/v5/tile',
  siteSearch: '/v1',
  paiAPIVersion: '/v8',
  paiMataDataAPIVersion: '/v5',
  syncUrl: '/v1',
  siteService: 'v1',
  assetService: '/v1',
  siteHistory: '/v1',
  liveHistory: '/v2',
  uiTemplate: '/v2',
  siteListReport: '/v1',
  rawData: '/v3',
  userAccountDelete: '/v1',
  tempAndCons: '/v1',
  azToken: '/v1',
  userAssociation: '/v1',
  invitationMgnt: '/v1',
  tmm: '/v2',
  tmmConfig: 'v2',
  helpCenter: '/v1',
  events: '/v2',
  eulaTou: '/v2',
  portal: '/v1',
  adr: '/v1',
  favorites: '/v2',
};

// Dev/Staging non-beta: beta prefixes for user/auth endpoints only
const DEV_STAGING_API_VERSIONS = {
  ...BASE_API_VERSIONS,
  inventoryReport: '/beta/v2',
  favorites: '/v2',
};

// ============================================================
// Tier-level authentication & identity configuration
// ============================================================

const DEV_TIER = {
  tenant: 'connectcortix.onmicrosoft.com',
  signInPolicy: 'B2C_1A_Cortix_SignUpSignIn',
  impersonatePolicy: 'B2C_1A_Cortix_SignUpSignIn_Impr',
  applicationId: '0ebf8dad-081f-4e1d-a9fd-8a83dd60cde7',
  apiScopes: ['https://connectCortix.onmicrosoft.com/api/cortix_web_api'],
  forgotPasswordPolicy: 'B2C_1_CortixPasswordResetPolicy',
  authorityUrl: 'https://connectcortix.b2clogin.com/tfp/',
  knownAuthorities: ['connectcortix.b2clogin.com'],
  remoteConfigEnv: 'dev',
  firebaseAK: FIREBASE_AK_DEV,
  applicationInsights: false,
  appInsightsConnectionString: APP_INSIGHTS.DEV,
  intercomAppId: INTERCOM_APP_ID,
  intercomRegion: 'us',
};

const STAGING_TIER = {
  tenant: 'connectcortix.onmicrosoft.com',
  signInPolicy: 'B2C_1A_Cortix_SignUpSignIn_TESTING',
  impersonatePolicy: 'B2C_1A_Cortix_SignUpSignIn_TESTING_Impr',
  apiScopes: ['https://connectCortix.onmicrosoft.com/api/cortix_web_api'],
  forgotPasswordPolicy: 'B2C_1_CortixPasswordResetPolicy',
  authorityUrl: 'https://connectcortix.b2clogin.com/tfp/',
  knownAuthorities: ['connectcortix.b2clogin.com'],
  remoteConfigEnv: 'dev',
  firebaseAK: FIREBASE_AK_DEV,
  applicationInsights: false,
  appInsightsConnectionString: APP_INSIGHTS.INT,
  intercomAppId: INTERCOM_APP_ID,
  intercomRegion: 'us',
  azureMap: {
    clientId: AZURE_MAP.DEV_CLIENT,
    accessId: AZURE_MAP.INT_ACCESS,
  },
};

const PROD_EU_TIER = {
  tenant: 'LoginCortixR1.onmicrosoft.com',
  signInPolicy: 'B2C_1A_Cortix_SignUpSignIn',
  impersonatePolicy: 'B2C_1A_Cortix_SignUpSignIn_Impr',
  applicationId: 'b19367a3-64c3-4834-8686-c0ff4a3d4e7f',
  apiScopes: ['https://LoginCortixR1.onmicrosoft.com/api/cortix_web_api'],
  forgotPasswordPolicy: 'B2C_1_PRD_R1_PLATFORM_AADB2C_FORGOT_PASSWORD_POLICY',
  authorityUrl: 'https://logincortixr1.b2clogin.com/tfp/',
  knownAuthorities: ['logincortixr1.b2clogin.com'],
  defaultMeasurement: 'unit1',
  remoteConfigEnv: 'prod',
  firebaseAK: FIREBASE_AK,
  applicationInsights: true,
  appInsightsConnectionString: APP_INSIGHTS.PROD_EU,
  azureMap: {
    clientId: AZURE_MAP.PROD_EU_CLIENT,
    accessId: AZURE_MAP.PROD_EU_ACCESS,
  },
};

const PROD_US_TIER = {
  tenant: 'LoginCortixR2.onmicrosoft.com',
  signInPolicy: 'B2C_1A_Cortix_SignUpSignIn',
  impersonatePolicy: 'B2C_1A_Cortix_SignUpSignIn_Impr',
  apiScopes: ['https://LoginCortixR2.onmicrosoft.com/api/cortix_web_api'],
  forgotPasswordPolicy: 'B2C_1_PRD_R2_PLATFORM_AADB2C_FORGOT_PASSWORD_POLICY',
  authorityUrl: 'https://logincortixr2.b2clogin.com/tfp/',
  knownAuthorities: ['logincortixr2.b2clogin.com'],
  remoteConfigEnv: 'prod',
  firebaseAK: FIREBASE_AK,
  applicationInsights: true,
  appInsightsConnectionString: APP_INSIGHTS.PROD_US,
  intercomAppId: INTERCOM_APP_ID_PROD_US,
  intercomRegion: 'us',
  azureMap: {
    clientId: AZURE_MAP.PROD_US_CLIENT,
    accessId: AZURE_MAP.PROD_US_ACCESS,
  },
};

// ============================================================
// Factory functions for repetitive beta environment variants
// ============================================================

function createStagingBetaEnv(betaNum) {
  const betaPath = `/beta${betaNum}`;
  const base = 'https://ws.r2.cortix.ai';
  return {
    ...SHARED_DEFAULTS,
    ...STAGING_TIER,
    applicationId: '8551064f-74bd-4946-89b1-486c9d342835',
    ...(betaNum === 1 && {
      apiScopes: ['https://connectcortix.onmicrosoft.com/api/cortix_web_api'],
    }),
    redirectUri: `${base}${betaPath}/insights`,
    redirectUriImpersonate: `${base}${betaPath}/insights/impersonate`,
    postLogoutRedirectUri: `${base}${betaPath}/insights`,
    domain: base,
    dsAppLink: `${base}/beta/ds`,
    userAssociationUrl: `${base}${betaPath}/insights/user-association`,
    adminPortalUrl: `${base}${betaPath}/helpcenter/admin-account`,
    beta: true,
    apiVersions: DEV_STAGING_API_VERSIONS,
  };
}

function createProdUSBetaEnv(betaNum) {
  const betaPath = `/beta${betaNum}`;
  const base = 'https://insights.cortix.ai';
  return {
    ...SHARED_DEFAULTS,
    ...PROD_US_TIER,
    applicationId: 'a67e58bd-74af-4cf7-a5b4-645275469add',
    redirectUri: `${base}${betaPath}/insights`,
    redirectUriImpersonate: `${base}${betaPath}/insights/impersonate`,
    postLogoutRedirectUri: `${base}${betaPath}/insights`,
    domain: base,
    dsAppLink: `${base}/beta/ds`,
    userAssociationUrl: `${base}${betaPath}/insights/user-association`,
    adminPortalUrl: `${base}${betaPath}/helpcenter/admin-account`,
    beta: true,
    apiVersions: BASE_API_VERSIONS,
  };
}

// ============================================================
// Environment configurations
// ============================================================
export const config = {
  env: 'staging',

  // --- Development ---

  development_ui: {
    ...SHARED_DEFAULTS,
    ...DEV_TIER,
    appInsightsConnectionString: APP_INSIGHTS.INT,
    redirectUriImpersonate: 'https://ws.r1.cortix.ai/beta/insights/impersonate',
    redirectUri: 'http://localhost:3000/insights',
    postLogoutRedirectUri: 'http://localhost:3000/insights',
    domain: 'http://localhost:8010/proxy',
    dsAppLink: 'https://ws.r1.cortix.ai/beta/ds',
    userAssociationUrl:
      'https://ws.r1.cortix.ai/beta/insights/user-association',
    adminPortalUrl: 'https://ws.r1.cortix.ai/beta/helpcenter/admin-account',
    beta: true,
    view: {
      autoCollapse: false,
      navHistoryMaxDays: 2,
      multiFilter: true,
    },
    apiVersions: {
      ...DEV_STAGING_API_VERSIONS,
    },
    azureMap: {
      clientId: AZURE_MAP.DEV_CLIENT,
      accessId: AZURE_MAP.INT_ACCESS,
    },
  },

  development_k8: {
    ...SHARED_DEFAULTS,
    ...DEV_TIER,
    redirectUriImpersonate: 'https://ws.r1.cortix.ai/insights/impersonate',
    redirectUri: 'https://ws.r1.cortix.ai/insights',
    postLogoutRedirectUri: 'https://ws.r1.cortix.ai/insights',
    domain: 'https://ws.r1.cortix.ai',
    dsAppLink: 'https://ws.r1.cortix.ai/ds',
    userAssociationUrl:
      'https://ws.r1.cortix.ai/beta/insights/user-association',
    adminPortalUrl: 'https://ws.r1.cortix.ai/beta/helpcenter/admin-account',
    beta: true,
    apiVersions: BASE_API_VERSIONS,
    azureMap: {
      clientId: AZURE_MAP.DEV_CLIENT,
      accessId: AZURE_MAP.DEV_ACCESS,
    },
  },

  development_k8_beta: {
    ...SHARED_DEFAULTS,
    ...DEV_TIER,
    redirectUriImpersonate: 'https://ws.r1.cortix.ai/beta/insights/impersonate',
    redirectUri: 'https://ws.r1.cortix.ai/beta/insights',
    postLogoutRedirectUri: 'https://ws.r1.cortix.ai/beta/insights',
    domain: 'https://ws.r1.cortix.ai',
    dsAppLink: 'https://ws.r1.cortix.ai/beta/ds',
    userAssociationUrl:
      'https://ws.r1.cortix.ai/beta/insights/user-association',
    adminPortalUrl: 'https://ws.r1.cortix.ai/beta/helpcenter/admin-account',
    beta: true,
    apiVersions: {
      ...BASE_API_VERSIONS,
    },
    azureMap: {
      clientId: AZURE_MAP.DEV_CLIENT,
      accessId: AZURE_MAP.DEV_ACCESS,
    },
  },

  // --- Staging ---

  staging_k8: {
    ...SHARED_DEFAULTS,
    ...STAGING_TIER,
    applicationId: 'fffe94c4-f2a7-4f0d-b6e4-a8a35eeca5aa',
    redirectUriImpersonate: 'https://ws.r2.cortix.ai/insights/impersonate',
    redirectUri: 'https://ws.r2.cortix.ai/insights',
    postLogoutRedirectUri: 'https://ws.r2.cortix.ai/insights',
    domain: 'https://ws.r2.cortix.ai',
    dsAppLink: 'https://ws.r2.cortix.ai/ds',
    userAssociationUrl:
      'https://ws.r2.cortix.ai/beta/insights/user-association',
    adminPortalUrl: 'https://ws.r2.cortix.ai/beta/helpcenter/admin-account',
    apiVersions: DEV_STAGING_API_VERSIONS,
  },

  staging_beta_k8: {
    ...SHARED_DEFAULTS,
    ...STAGING_TIER,
    applicationId: 'fffe94c4-f2a7-4f0d-b6e4-a8a35eeca5aa',
    redirectUri: 'https://ws.r2.cortix.ai/beta/insights',
    redirectUriImpersonate: 'https://ws.r2.cortix.ai/beta/insights/impersonate',
    postLogoutRedirectUri: 'https://ws.r2.cortix.ai/beta/insights',
    domain: 'https://ws.r2.cortix.ai',
    dsAppLink: 'https://ws.r2.cortix.ai/beta/ds',
    userAssociationUrl:
      'https://ws.r2.cortix.ai/beta/insights/user-association',
    adminPortalUrl: 'https://ws.r2.cortix.ai/beta/helpcenter/admin-account',
    beta: true,
    apiVersions: DEV_STAGING_API_VERSIONS,
  },

  staging_beta1_k8: createStagingBetaEnv(1),
  staging_beta2_k8: createStagingBetaEnv(2),
  staging_beta3_k8: createStagingBetaEnv(3),
  staging_beta4_k8: createStagingBetaEnv(4),
  staging_beta5_k8: createStagingBetaEnv(5),

  // --- Production EU ---

  production_r1: {
    ...SHARED_DEFAULTS,
    ...PROD_EU_TIER,
    redirectUriImpersonate: 'https://access.cortix.ai/insights/impersonate',
    redirectUri: 'https://access.cortix.ai/insights',
    postLogoutRedirectUri: 'https://access.cortix.ai/insights',
    domain: 'https://access.cortix.ai',
    dsAppLink: 'https://access.cortix.ai/ds',
    userAssociationUrl: 'https://access.cortix.ai/insights/user-association',
    adminPortalUrl: 'https://access.cortix.ai/helpcenter/admin-account',
    apiVersions: BASE_API_VERSIONS,
  },

  production_eu_beta_k8: {
    ...SHARED_DEFAULTS,
    ...PROD_EU_TIER,
    redirectUriImpersonate:
      'https://access.cortix.ai/beta/insights/impersonate',
    redirectUri: 'https://access.cortix.ai/beta/insights',
    postLogoutRedirectUri: 'https://access.cortix.ai/beta/insights',
    domain: 'https://access.cortix.ai',
    dsAppLink: 'https://access.cortix.ai/beta/ds',
    userAssociationUrl:
      'https://access.cortix.ai/beta/insights/user-association',
    adminPortalUrl: 'https://access.cortix.ai/beta/helpcenter/admin-account',
    beta: true,
    apiVersions: BASE_API_VERSIONS,
  },

  // --- Production US ---

  production_r2: {
    ...SHARED_DEFAULTS,
    ...PROD_US_TIER,
    applicationId: '1dbfb792-bb4d-4938-bb54-bc84df181c27',
    redirectUriImpersonate: 'https://insights.cortix.ai/insights/impersonate',
    redirectUri: 'https://insights.cortix.ai/insights',
    forgotPasswordPolicy: 'B2C_1_PRD_R2_PLATFORM_AADB2C_FORGOT_PASSWORD_POLICY',
    postLogoutRedirectUri: 'https://insights.cortix.ai/insights',
    domain: 'https://insights.cortix.ai',
    dsAppLink: 'https://insights.cortix.ai/ds',
    userAssociationUrl: 'https://insights.cortix.ai/insights/user-association',
    adminPortalUrl: 'https://insights.cortix.ai/helpcenter/admin-account',
    apiVersions: BASE_API_VERSIONS,
  },

  production_us_beta_K8: {
    ...SHARED_DEFAULTS,
    ...PROD_US_TIER,
    applicationId: '1dbfb792-bb4d-4938-bb54-bc84df181c27',
    redirectUriImpersonate:
      'https://insights.cortix.ai/beta/insights/impersonate',
    redirectUri: 'https://insights.cortix.ai/beta/insights',
    postLogoutRedirectUri: 'https://insights.cortix.ai/beta/insights',
    domain: 'https://insights.cortix.ai',
    dsAppLink: 'https://insights.cortix.ai/beta/ds',
    userAssociationUrl:
      'https://insights.cortix.ai/beta/insights/user-association',
    adminPortalUrl: 'https://insights.cortix.ai/beta/helpcenter/admin-account',
    beta: true,
    apiVersions: BASE_API_VERSIONS,
  },

  production_us_beta1_K8: createProdUSBetaEnv(1),
  production_us_beta2_K8: createProdUSBetaEnv(2),
  production_us_beta3_K8: createProdUSBetaEnv(3),
  production_us_beta4_K8: createProdUSBetaEnv(4),
  production_us_beta5_K8: createProdUSBetaEnv(5),
};
